import { createContext, ReactNode, useCallback, useContext, useRef } from "react";

export type GetGraphPngFn = () => Promise<string | null>;

type FolderGraphExportContextType = {
  /** Récupère une image PNG du graphe (data URL) si le graphe est monté, sinon null. */
  getGraphPng: () => Promise<string | null>;
  /** Enregistre la fonction d'export du graphe (appelée par le composant qui rend le graphe). */
  registerGetPng: (fn: GetGraphPngFn | null) => void;
};

const FolderGraphExportContext = createContext<FolderGraphExportContextType | undefined>(undefined);

type FolderGraphExportProviderProps = {
  children: ReactNode;
};

export function FolderGraphExportProvider({ children }: FolderGraphExportProviderProps) {
  const getPngRef = useRef<GetGraphPngFn | null>(null);

  const registerGetPng = useCallback((fn: GetGraphPngFn | null) => {
    getPngRef.current = fn;
  }, []);

  const getGraphPng = useCallback(async (): Promise<string | null> => {
    if (!getPngRef.current) return null;
    return getPngRef.current();
  }, []);

  return (
    <FolderGraphExportContext.Provider value={{ getGraphPng, registerGetPng }}>
      {children}
    </FolderGraphExportContext.Provider>
  );
}

export function useFolderGraphExport(): FolderGraphExportContextType {
  const context = useContext(FolderGraphExportContext);
  if (context === undefined) {
    throw new Error("useFolderGraphExport must be used within FolderGraphExportProvider");
  }
  return context;
}
